import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class ProgramsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
              args: args, 
              programs: []  
        }
    }  
    
    async componentDidMount() {
        BaseApi.get('/programs', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.setState({programs: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openProgram(id) {
        this.props.navigate("program", {caller: "programs", callargs: this.state.args, program: id})
    }

    renderProgram(program) {
        return (
            <tr
                id = {program.id}
                className="table-row-clickable"
                onClick={()=>this.openProgram(program.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {program.name}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {program.description}
                </td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Программы"}/>
                 <div className="row mt-4 mb-3">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7 d-flex align-items-start justify-content-end mt-3 mt-lg-0">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            onClick={() => this.openProgram("")}
                        >
                            Добавить программу
                        </button>
                    </div>
                 </div>
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="nameCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Наименование
                                        </th>
                                        <th id="descriptionCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Описание
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.programs.map((value, index) => this.renderProgram(value))}
                                </tbody>
                            </table>      
                        </div>
                    </div>
                </div>        
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/programs.js